// extracted by mini-css-extract-plugin
var _1 = "GroupingElement_pdfGroup__b1e28";
var _2 = "GroupingElement_root__b08f7";
export { _1 as "pdfGroup", _2 as "root" }
